export const environment = {
  cdn: 'https://cdn-maximizer-dev.azureedge.net',
  bookDemoUrl: 'https://www.maximizer.com/book-a-demo/',
  bookDemoUrlFr: 'https://www.maximizer.com/fr-ca/book-a-demo/',
  aiCrmUrl: 'https://www.maximizer.com/features/ai-crm/',
  aiCrmUrlFr: 'https://www.maximizer.com/fr-ca/features/ai-crm/',
};
